<template>
  <div>
    <div class="mrB20" />
    <sui-grid
      ref="tabGrid"
      :dataset="'ds0'"
      :columns="gridColumnsTab"
      :multiselect="true"
      :showDisplayCountControl="false"
    >
      <div class="comp_spacing" />
      <div class="btn_wrapL">
        <sui-button
          v-permission:create="pageId"
          type="button"
          class="comm_btn_gridTop"
          @click="onNewClick"
        >
          {{ $t('MSG_BTN_ADD') }}
        </sui-button>
        <sui-button
          v-permission:delete="pageId"
          type="button"
          class="comm_btn_gridTop"
          @click="onDelClick"
        >
          {{ $t('MSG_BTN_DEL') }}
        </sui-button>
      </div>
    </sui-grid>
    <div class="comm_btn_wrap">
      <sui-button
        v-permission:update="pageId"
        type="button"
        class="comm_btn_solid"
        :disabled="checkMetaSave"
        @click="onSaveClick"
      >
        {{ $t('MSG_BTN_SAVE') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMU_00007_T04', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: '',
    },
    componentId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      gridColumnsTab: [{
        text: this.$t('MSG_TXT_TYPE'),
        datafield: 'componentTypeName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_MDLE'),
        datafield: 'moduleName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_SMDLE'),
        datafield: 'subModuleName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_CMPNT_ID'),
        datafield: 'componentId',
      }, {
        text: this.$t('MSG_TXT_CMPNT_NM'),
        datafield: 'componentName',
      }, {
        text: this.$t('MSG_TXT_TAG'),
        datafield: 'componentTag',
      }],
      localdata3: [],
      selectMessage: utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_CMPNT')),
    };
  },
  computed: {
    checkMetaSave() {
      return utils.checkMetaSave();
    },
  },
  watch: {
    componentId() {
      if (this.componentId) {
        this.selectSubComponent();
      } else {
        this.tabGridClear();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.componentId) {
        this.selectSubComponent();
      }
    });
  },
  datasets: [{
    id: 'ds0',
    type: 'local',
    data: 'localdata3',
    datafields: [
      { type: 'string', name: 'componentId', map: 'componentId' },
      { type: 'string', name: 'componentTypeCode', map: 'componentTypeCode' },
      { type: 'string', name: 'componentTypeName', map: 'componentTypeName' },
      { type: 'string', name: 'moduleCode', map: 'moduleCode' },
      { type: 'string', name: 'subModuleCode', map: 'subModuleCode' },
      { type: 'string', name: 'componentName', map: 'componentName' },
      { type: 'string', name: 'componentTag', map: 'componentTag' },
      { type: 'string', name: 'moduleName', map: 'moduleName' },
      { type: 'string', name: 'subModuleName', map: 'subModuleName' },
    ],
  }],
  methods: {
    selectSubComponent() {
      // 선택한 컴포넌트 등록 서브컴포넌트 목록 조회
      http.request(this.pageId, 'DTS_CMU_00048', {
        path: {
          'component-id': this.componentId,
        },
      }).then(res => {
        this.ds0.setRawData(res.data);
      }).catch(error => {
        console.log(error);
      });
    },
    tabGridClear() {
      this.ds0.setRawData([]);
    },
    onNewClick() {
      if (!this.componentId) {
        utils.messageBox('warning', this.selectMessage);
      } else {
        utils.openLayerPopup('PGE_CMU_00008', this.onPopupClose, {
          pageInitialData: { multiSelect: true },
          size: 'lg',
        });
      }
    },
    onPopupClose(nodeData) {
      if (!utils.isEmpty(nodeData)) {
        this.addRows(nodeData);
      }
    },
    addRows(list) {
      const addNewRows = [];
      const componentList = this.ds0.getRawData();
      utils.forEach(list, data => {
        const { componentId } = data;
        if (utils.findIndex(componentList, { componentId }) === -1) {
          addNewRows.push(data);
        }
      });
      if (addNewRows.length > 0) {
        this.ds0.addRows(addNewRows);
      }
    },
    onDelClick() {
      if (!this.componentId) {
        utils.messageBox('warning', this.selectMessage);
      } else if (this.ds0.getSelectedIndexes().length === 0) {
        utils.messageBox('warning', this.$t('MSG_ALT_DEL_DATA_SELT'));
      } else {
        const indexes = this.ds0.getSelectedIndexes();
        this.ds0.deleteRows(indexes);
      }
    },
    onSaveClick() {
      if (!this.componentId) {
        utils.messageBox('warning', this.selectMessage);
      } else {
        utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
          const subComponentList = this.ds0.getRawData();
          const dataParams = [];
          if (subComponentList.length !== 0) {
            subComponentList.forEach(subComponent => {
              dataParams.push({
                componentId: this.componentId,
                subComponentId: subComponent.componentId,
              });
            });
          } else {
            dataParams.push({
              componentId: this.componentId,
            });
          }

          http.request(this.pageId, 'DTS_CMU_00049', {
            path: {
              'component-id': this.componentId,
            },
            data: dataParams,
          }).then(() => {
            utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'), null, () => {
              this.ds0.submit();
            });
          }).catch(error => {
            console.log(error);
          });
        });
      }
    },
  },
};
</script>
<style scoped>
</style>
